export const  BASE_URL="https://feedback.asasigroup.com/"
export const IMAGE_URL ="https://www.shopkees.com/cdn/images/100/"
export const APP_URL ="https://portal.asasigroup.com/"
//export const SITE_URL ="https://uae-en.shopkees.com/"
//export const MAIN_URL ="https://www.shopkees.com/"
